import React from "react";
import { Navigate } from "react-router-dom";

// Guards public-only screens such as login so authenticated users are pushed into the app.
const PublicRoute = ({ isAuthenticated, children }) => {
  // Show the public page when the user is signed out, otherwise redirect to the dashboard.
  return !isAuthenticated ? children : <Navigate to="/dashboard" replace />;
};

export default PublicRoute;
